(function () {
  "use strict";
  if (window.PFAccount) return;

  var template = document.querySelector("[data-pf-account-template]");
  var strings = document.querySelector("[data-pf-account-strings]");
  if (!template || !strings) return;

  var t = JSON.parse(strings.textContent);
  var dialog = template.content.firstElementChild.cloneNode(true);
  document.body.appendChild(dialog);
  var api = window.PFApi;
  var preview;
  var verificationIds = { email: null, phone: null };
  var timer;
  var resendTimer;
  var busy = false;
  var pollCount = 0;
  var currentMode = "all";
  var inlineContactFlow = false;
  var pendingContacts = { email: "", phone: "" };
  var cachedPerson = null;
  var cachedPersonAt = 0;
  var resolutionKey = "pf:contact:resolution";
  var photoLoadId = 0;
  var photoState = {
    file: null,
    image: null,
    zoom: 1,
    x: 0,
    y: 0,
    pointers: new Map(),
    gesture: null,
  };
  var PHOTO_MAX_BYTES = 20 * 1024 * 1024;
  var PHOTO_MAX_DIMENSION = 4472;
  var PHOTO_MAX_PIXELS = 20000000;
  var PHOTO_OUTPUT_SIZE = 512;
  var PHOTO_TYPES = ["image/jpeg", "image/png", "image/webp"];

  // Phone numbers are Indian mobiles only (+91 and 10 digits starting 6-9).
  // Every phone field shows a fixed +91 and holds just the 10 digits; see
  // assets/pf-indian-phone.js.
  function normalizePhone(value) {
    var cleaned = String(value || "").replace(/[\s\-().]/g, "");
    if (/^\+91[6-9]\d{9}$/.test(cleaned)) return cleaned;
    var digits = cleaned.replace(/^0+/, "");
    if (/^[6-9]\d{9}$/.test(digits)) return "+91" + digits;
    if (/^91[6-9]\d{9}$/.test(digits)) return "+" + digits;
    return "";
  }

  function phoneHelper() {
    return window.PFIndianPhone || null;
  }

  function nationalPhone(value) {
    return phoneHelper()
      ? phoneHelper().national(value)
      : String(value || "").replace(/^\+91/, "");
  }

  function canonicalPhone(value) {
    return phoneHelper()
      ? phoneHelper().canonical(value)
      : normalizePhone(value);
  }

  function phoneError(value) {
    if (phoneHelper()) return phoneHelper().error(value);
    return normalizePhone(value) ? "" : t.phone_invalid;
  }

  function contactInputValue(input) {
    var value = input.value.trim();
    if (input.dataset.pfContactKind !== "phone") return value;
    return canonicalPhone(value);
  }

  function setContactInputValue(input, value) {
    if (input.dataset.pfContactKind !== "phone") {
      input.value = value;
      return;
    }
    if (phoneHelper()) phoneHelper().fill(input, value);
    else input.value = nationalPhone(value);
  }

  function q(selector) {
    return dialog.querySelector(selector);
  }

  function status(message, error) {
    q("[data-status]").textContent = message || "";
    q("[data-status]").dataset.error = error ? "true" : "false";
  }

  function photoError(message, focus) {
    var input = q("[name=photo]");
    var error = q("[data-photo-error]");
    input.setAttribute("aria-invalid", message ? "true" : "false");
    if (!message) input.removeAttribute("aria-invalid");
    error.textContent = message || "";
    error.hidden = !message;
    if (message && focus) {
      input.focus();
      error.scrollIntoView({ block: "nearest" });
    }
  }

  function formatPhotoSize(bytes) {
    if (bytes < 1024 * 1024)
      return Math.max(1, Math.round(bytes / 1024)) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  }

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function photoGeometry() {
    var image = photoState.image;
    var coverScale = Math.max(
      PHOTO_OUTPUT_SIZE / image.naturalWidth,
      PHOTO_OUTPUT_SIZE / image.naturalHeight,
    );
    var scale = coverScale * photoState.zoom;
    var width = image.naturalWidth * scale;
    var height = image.naturalHeight * scale;
    return {
      width: width,
      height: height,
      limitX: Math.max(0, (width - PHOTO_OUTPUT_SIZE) / 2),
      limitY: Math.max(0, (height - PHOTO_OUTPUT_SIZE) / 2),
    };
  }

  function constrainPhotoPosition() {
    if (!photoState.image) return;
    var geometry = photoGeometry();
    photoState.x = clamp(photoState.x, -geometry.limitX, geometry.limitX);
    photoState.y = clamp(photoState.y, -geometry.limitY, geometry.limitY);
  }

  function drawPhotoCrop() {
    if (!photoState.image) return;
    var image = photoState.image;
    var canvas = q("[data-photo-canvas]");
    var context = canvas.getContext("2d", { alpha: false });
    if (!context) throw new Error(t.photo_invalid);
    constrainPhotoPosition();
    var geometry = photoGeometry();
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, PHOTO_OUTPUT_SIZE, PHOTO_OUTPUT_SIZE);
    context.drawImage(
      image,
      (PHOTO_OUTPUT_SIZE - geometry.width) / 2 + photoState.x,
      (PHOTO_OUTPUT_SIZE - geometry.height) / 2 + photoState.y,
      geometry.width,
      geometry.height,
    );
    q('[data-photo-value="zoom"]').textContent =
      Math.round(photoState.zoom * 100) + "%";
  }

  function setPhotoZoom(value) {
    photoState.zoom = clamp(value, 1, 3);
    drawPhotoCrop();
  }

  function resetPhotoCrop() {
    photoState.zoom = 1;
    photoState.x = 0;
    photoState.y = 0;
    photoState.pointers.clear();
    photoState.gesture = null;
    drawPhotoCrop();
  }

  function pointerSnapshot() {
    var points = Array.from(photoState.pointers.values());
    if (!points.length) return null;
    var x = points.reduce(function (sum, point) {
      return sum + point.x;
    }, 0) / points.length;
    var y = points.reduce(function (sum, point) {
      return sum + point.y;
    }, 0) / points.length;
    var distance = 0;
    if (points.length > 1) {
      distance = Math.hypot(
        points[0].x - points[1].x,
        points[0].y - points[1].y,
      );
    }
    return { x: x, y: y, distance: distance };
  }

  function movePhotoBy(x, y) {
    photoState.x += x;
    photoState.y += y;
    drawPhotoCrop();
  }

  function finishPhotoPointer(event) {
    photoState.pointers.delete(event.pointerId);
    photoState.gesture = pointerSnapshot();
    if (!photoState.pointers.size)
      q("[data-photo-crop-surface]").removeAttribute("data-dragging");
  }

  function clearPhotoSelection(focus) {
    photoLoadId += 1;
    photoState.file = null;
    photoState.image = null;
    photoState.pointers.clear();
    photoState.gesture = null;
    q("[name=photo]").value = "";
    q("[data-photo-editor]").hidden = true;
    q("[data-photo-file]").textContent = "";
    photoError("");
    if (focus) q("[name=photo]").focus();
  }

  async function preparePhoto(file) {
    var loadId = ++photoLoadId;
    photoState.file = null;
    photoState.image = null;
    photoState.pointers.clear();
    photoState.gesture = null;
    q("[data-photo-editor]").hidden = true;
    photoError("");
    if (
      !file ||
      !file.size ||
      file.size > PHOTO_MAX_BYTES ||
      PHOTO_TYPES.indexOf(file.type) === -1
    )
      throw new Error(t.photo_invalid);

    var objectUrl = URL.createObjectURL(file);
    var image = new Image();
    try {
      image.src = objectUrl;
      await image.decode();
    } finally {
      URL.revokeObjectURL(objectUrl);
    }
    if (loadId !== photoLoadId) return;
    if (
      !image.naturalWidth ||
      !image.naturalHeight ||
      image.naturalWidth > PHOTO_MAX_DIMENSION ||
      image.naturalHeight > PHOTO_MAX_DIMENSION ||
      image.naturalWidth * image.naturalHeight > PHOTO_MAX_PIXELS
    )
      throw new Error(t.photo_invalid);

    photoState.file = file;
    photoState.image = image;
    q("[data-photo-file]").textContent = t.selected_photo
      .replace("{name}", file.name)
      .replace("{size}", formatPhotoSize(file.size));
    q("[data-photo-editor]").hidden = false;
    resetPhotoCrop();
  }

  function croppedPhoto() {
    return new Promise(function (resolve, reject) {
      if (!photoState.image) {
        reject(new Error(t.photo_invalid));
        return;
      }
      drawPhotoCrop();
      q("[data-photo-canvas]").toBlob(
        function (blob) {
          if (!blob || !blob.size) reject(new Error(t.photo_invalid));
          else resolve(blob);
        },
        "image/jpeg",
        0.88,
      );
    });
  }

  function storage(value) {
    try {
      if (arguments.length) {
        if (value) sessionStorage.setItem(resolutionKey, value);
        else sessionStorage.removeItem(resolutionKey);
      }
      return sessionStorage.getItem(resolutionKey);
    } catch (_) {
      return null;
    }
  }

  function fail(error) {
    status(error.message || t.check_error, true);
    if (error.fields && error.fields.resolutionId) {
      storage(error.fields.resolutionId);
      q("[data-check-status]").hidden = false;
    }
    if (
      [
        "UNAUTHENTICATED",
        "REAUTHENTICATION_REQUIRED",
        "SESSION_EXPIRED",
      ].indexOf(error.code) !== -1
    ) {
      var link = q("[data-signin]");
      var config =
        window.PFProfileSession && window.PFProfileSession.config
          ? window.PFProfileSession.config()
          : {};
      var url = new URL(
        (config.urls || {}).signIn || "/pages/signup-in",
        location.origin,
      );
      var back = new URL(location.href);
      back.searchParams.set("pf_account", currentMode);
      url.searchParams.set("return_to", back.pathname + back.search);
      link.href = url.toString();
      link.hidden = false;
    }
  }

  async function work(button, action) {
    if (busy) return;
    busy = true;
    if (button) button.disabled = true;
    status(t.loading);
    try {
      await action();
    } catch (error) {
      fail(error);
    } finally {
      busy = false;
      if (button) button.disabled = false;
    }
  }

  function updatePhoto(url, person) {
    document.querySelectorAll("[data-pf-avatar]").forEach(function (avatar) {
      var initial = person
        ? (
            (person.firstName || "").slice(0, 1) +
            (person.lastName || "").slice(0, 1)
          ).toUpperCase()
        : avatar.dataset.initials || "";
      avatar.dataset.initials = initial;
      avatar.replaceChildren();
      if (url && /^https:\/\//i.test(url)) {
        var img = document.createElement("img");
        img.src = url;
        img.alt = "";
        img.addEventListener(
          "error",
          function () {
            avatar.textContent = initial;
          },
          { once: true },
        );
        avatar.appendChild(img);
      } else {
        avatar.textContent = initial;
      }
    });
  }

  function setMode(mode, focus) {
    if (["photo", "marketing", "email", "phone"].indexOf(mode) === -1)
      mode = "all";
    currentMode = mode;
    inlineContactFlow = false;
    delete dialog.dataset.contactFlow;
    clearInterval(resendTimer);
    dialog.dataset.mode = mode;
    var titles = {
      photo: t.photo_title,
      marketing: t.marketing_title,
      email: t.email_title,
      phone: t.phone_title,
      all: t.title,
    };
    q("[data-dialog-title]").textContent = titles[mode] || t.title;
    dialog
      .querySelectorAll("[data-account-section]")
      .forEach(function (section) {
        var sectionName = section.getAttribute("data-account-section");
        section.hidden =
          sectionName === "preview" ||
          (mode !== "all" &&
            sectionName !== mode &&
            !(
              sectionName === "contacts" &&
              (mode === "email" || mode === "phone")
            ));
      });
    dialog.querySelectorAll("[data-contact-method]").forEach(function (node) {
      var method = node.getAttribute("data-contact-method");
      node.hidden =
        (mode === "email" && method !== "email") ||
        (mode === "phone" && method !== "phone");
    });
    q("[data-email-code-form]").hidden = true;
    q("[data-phone-code-form]").hidden = true;
    q("[data-code-instruction]").hidden = true;
    q("[data-preview]").hidden = true;
    status("");
    if (focus) {
      var selector =
        mode === "email"
          ? "[name=email]"
          : mode === "phone"
            ? "[name=phone]"
            : mode === "photo"
              ? "[name=photo]"
              : mode === "marketing"
                ? "[name=subscribed]"
                : "";
      if (selector) q(selector).focus();
    }
  }

  function renderMarketing(person) {
    var subscribed = person.marketingState === "SUBSCRIBED";
    var hasVerifiedEmail = Boolean(person.email && person.emailVerified);
    var checkbox = q("[name=subscribed]");
    var submit = q("[data-marketing-form] [type=submit]");
    checkbox.checked = subscribed;
    checkbox.disabled = !hasVerifiedEmail && !subscribed;
    submit.disabled = !hasVerifiedEmail && !subscribed;
    q("[data-marketing-state]").textContent = subscribed
      ? t.subscribed
      : person.marketingState
        ? t.unsubscribed
        : t.unknown;
    q("[data-marketing-email]").textContent = person.email
      ? t.order_email + " " + person.email
      : t.email_required;
    q("[data-open-email]").hidden = hasVerifiedEmail;
  }

  function syncVisibleContactInputs(person, force) {
    document
      .querySelectorAll("[data-pf-contact-kind]")
      .forEach(function (node) {
        var value =
          node.dataset.pfContactKind === "email"
            ? person.email || ""
            : person.phone || "";
        node.dataset.pfContactCurrent = value;
        if (force || node.dataset.pfContactDirty !== "true") {
          setContactInputValue(node, value);
          node.dataset.pfContactDirty = "false";
        }
      });
    refreshPhoneControls(person);
  }

  function isVerifiedPhone(value, person) {
    var candidate = normalizePhone(value);
    var canonical = normalizePhone((person || cachedPerson || {}).phone);
    return Boolean(
      candidate &&
        canonical &&
        (person || cachedPerson || {}).phoneVerified &&
        candidate === canonical,
    );
  }

  function refreshPhoneControls(person) {
    var profile = person || cachedPerson;
    document
      .querySelectorAll('[data-pf-contact-kind="phone"]')
      .forEach(function (input) {
        var verified = isVerifiedPhone(contactInputValue(input), profile);
        input.dataset.pfContactVerified = verified ? "true" : "false";
        var field = input.closest(".pf-demo-field");
        if (!field) return;
        var button = field.querySelector('[data-pf-contact-verify="phone"]');
        if (button) {
          button.disabled = verified;
          button.textContent = verified ? t.verified : t.verify;
        }
        var state = field.querySelector('[data-pf-contact-status="phone"]');
        if (state) {
          state.textContent = verified ? t.phone_verified : "";
          state.hidden = !verified;
        }
      });
  }

  function renderPerson(person) {
    cachedPerson = person;
    cachedPersonAt = Date.now();
    q("[data-contacts]").textContent =
      [person.email, person.phone].filter(Boolean).join(" · ") || t.not_set;
    q("[name=email]").value = person.email || "";
    q("[name=phone]").value = nationalPhone(person.phone);
    renderMarketing(person);
    updatePhoto(person.photoUrl, person);
    document
      .querySelectorAll("[data-pf-consent-status]")
      .forEach(function (node) {
        node.textContent = q("[data-marketing-state]").textContent;
      });
    syncVisibleContactInputs(person, false);
    document.dispatchEvent(
      new CustomEvent("pf:account:loaded", { detail: { profile: person } }),
    );
    return person;
  }

  async function load(force) {
    if (!force && cachedPerson && Date.now() - cachedPersonAt < 30000)
      return renderPerson(cachedPerson);
    var result = await api.get("/v1/me");
    return renderPerson(result.profile);
  }

  async function confirmPreview(auto) {
    pollCount = 0;
    var back = api.contactReturn();
    if (!back.nonce) {
      var returnUrl = new URL(location.href);
      returnUrl.searchParams.set("pf_account", currentMode);
      returnUrl.searchParams.set("pf_contact", "verified");
      if (auto) returnUrl.searchParams.set("pf_contact_auto", "1");
      history.replaceState(null, "", returnUrl);
      if (await api.resumeSession(true)) return;
      throw new Error(t.check_error);
    }
    await resolved(
      await api.post(
        "/v1/me/contacts",
        Object.assign(
          { confirm: true, previewToken: preview.previewToken },
          back,
        ),
      ),
    );
  }

  async function showPreview(autoConfirm) {
    var body = await api.get("/v1/me/contacts", {
      query: api.contactReturn(),
    });
    if (body.resolutionId) {
      await resolved(body);
      return;
    }
    preview = body.preview;
    if (autoConfirm && !preview.mergesAccounts && !preview.requiresReview) {
      await confirmPreview(true);
      return;
    }
    clearInterval(resendTimer);
    dialog.dataset.contactFlow = "review";
    q('[data-account-section="contacts"]').hidden = true;
    q("[data-code-instruction]").hidden = true;
    q("[data-email-code-form]").hidden = true;
    q("[data-phone-code-form]").hidden = true;
    q("[data-preview]").hidden = false;
    q("[data-preview-message]").textContent = preview.message;
    q("[data-preview-contacts]").textContent = [preview.email, preview.phone]
      .filter(Boolean)
      .join(" · ");
    q("[data-preview-orders]").textContent =
      t.current_orders +
      " " +
      preview.currentOrderCount +
      (preview.otherOrderCount === null
        ? ""
        : " · " + t.other_orders + " " + preview.otherOrderCount);
    q("[data-preview]").scrollIntoView({ block: "nearest" });
    status("");
  }

  async function resolved(result) {
    if (result.status === "resolved") {
      if (result.sharedSessionUrl) {
        storage(null);
        location.replace(result.sharedSessionUrl);
        return;
      }
      storage(null);
      q("[data-check-status]").hidden = true;
      q("[data-preview]").hidden = true;
      var back = new URL(location.href);
      back.searchParams.delete("pf_contact");
      back.searchParams.delete("pf_contact_auto");
      back.searchParams.delete("pf_account");
      history.replaceState(null, "", back);
      if (
        result.sessionRotated &&
        api.syncSharedSession &&
        api.syncSharedSession(back.toString())
      )
        return;
      document
        .querySelectorAll('[data-pf-contact-kind="' + currentMode + '"]')
        .forEach(function (node) {
          node.dataset.pfContactDirty = "false";
        });
      await load(true);
      status(t.linked);
      document.dispatchEvent(new CustomEvent("pf:account:changed"));
      return;
    }
    storage(result.resolutionId);
    q("[data-check-status]").hidden = false;
    if (result.status === "open") {
      status(t.review_reference + " " + result.resolutionId);
      return;
    }
    status(t.working);
    clearTimeout(timer);
    if (++pollCount < 30 && dialog.open)
      timer = setTimeout(function () {
        checkStatus().catch(fail);
      }, 2000);
    else status(t.pending);
  }

  async function checkStatus() {
    var id = storage();
    if (id)
      await resolved(
        await api.get("/v1/me/contacts", {
          query: Object.assign({ resolution: id }, api.contactReturn()),
        }),
      );
  }

  async function open(mode) {
    setMode(mode || "all", true);
    if (!dialog.open) dialog.showModal();
    status(t.loading);
    q("[data-signin]").hidden = true;
    try {
      await load();
      if (storage()) {
        pollCount = 0;
        await checkStatus();
      } else if (
        new URL(location.href).searchParams.get("pf_contact") === "verified"
      ) {
        var autoContact =
          new URL(location.href).searchParams.get("pf_contact_auto") === "1";
        inlineContactFlow = autoContact;
        await showPreview(autoContact);
      }
    } catch (error) {
      fail(error);
    }
  }

  dialog.addEventListener("close", function () {
    clearTimeout(timer);
    clearInterval(resendTimer);
    verificationIds.email = null;
    verificationIds.phone = null;
    pendingContacts.email = "";
    pendingContacts.phone = "";
    q("[name=email_code]").value = "";
    q("[name=phone_code]").value = "";
  });
  q("[data-close]").addEventListener("click", function () {
    dialog.close();
  });
  q("[data-cancel-preview]").addEventListener("click", function () {
    if (inlineContactFlow) dialog.close();
    else setMode(currentMode, true);
  });
  q("[data-open-email]").addEventListener("click", function () {
    setMode("email", true);
  });

  q("[data-google]").addEventListener("click", function (event) {
    work(event.currentTarget, async function () {
      var back = new URL(location.href);
      back.searchParams.delete("pf_contact");
      back.searchParams.set("pf_account", "email");
      var body = await api.post("/v1/me/contacts/google", {
        returnTo: back.toString(),
      });
      location.assign(body.url);
    });
  });

  function scheduleResend(method, seconds) {
    clearInterval(resendTimer);
    var button = q('[data-contact-resend="' + method + '"]');
    var left = Math.max(0, Number(seconds) || 0);
    function render() {
      button.disabled = left > 0;
      button.textContent = left > 0 ? t.resend_in + " " + left + "s" : t.resend;
    }
    render();
    if (!left) return;
    resendTimer = setInterval(function () {
      left -= 1;
      render();
      if (left <= 0) clearInterval(resendTimer);
    }, 1000);
  }

  async function startContact(method, value) {
    var body = await api.post("/v1/me/contacts/" + method + "/start", {
      [method]: value,
    });
    verificationIds[method] = body.verificationId;
    pendingContacts[method] = value;
    q("[data-" + method + "-code-form]").hidden = false;
    q("[name=" + method + "_code]").focus();
    scheduleResend(method, body.resendAfterSec);
    status("");
  }

  function beginInlineContact(method, input, button) {
    var value = contactInputValue(input);
    // An empty phone gets the phone-specific message from phoneError below.
    if (!value && method !== "phone") {
      var emptySlot = input
        .closest(".pf-demo-field")
        ?.querySelector('[data-pf-field-error="' + method + '"]');
      input.setAttribute("aria-invalid", "true");
      input.classList.add("is-invalid");
      if (emptySlot) {
        emptySlot.textContent = t.contact_required;
        emptySlot.hidden = false;
      }
      input.focus();
      return;
    }
    var phoneProblem = method === "phone" ? phoneError(input.value) : "";
    if (phoneProblem) {
      var slot = input
        .closest(".pf-demo-field")
        ?.querySelector('[data-pf-field-error="phone"]');
      input.setAttribute("aria-invalid", "true");
      input.classList.add("is-invalid");
      if (slot) {
        slot.textContent = phoneProblem;
        slot.hidden = false;
      }
      input.focus();
      return;
    }
    input.removeAttribute("aria-invalid");
    input.classList.remove("is-invalid");
    var existingSlot = input
      .closest(".pf-demo-field")
      ?.querySelector('[data-pf-field-error="' + method + '"]');
    if (existingSlot) {
      existingSlot.textContent = "";
      existingSlot.hidden = true;
    }
    setMode(method);
    inlineContactFlow = true;
    dialog.dataset.contactFlow = "code-only";
    q("[data-code-instruction]").hidden = false;
    q("[name=" + method + "]").value =
      method === "phone" ? nationalPhone(value) : value;
    if (!dialog.open) dialog.showModal();
    q("[data-signin]").hidden = true;
    work(button, async function () {
      status(t.sending_code);
      await startContact(method, value);
    });
  }

  q("[data-email-form]").addEventListener("submit", function (event) {
    event.preventDefault();
    work(event.submitter, function () {
      return startContact("email", q("[name=email]").value.trim());
    });
  });
  q("[data-email-code-form]").addEventListener("submit", function (event) {
    event.preventDefault();
    work(event.submitter, async function () {
      await api.post("/v1/me/contacts/email/verify", {
        verificationId: verificationIds.email,
        code: q("[name=email_code]").value,
      });
      q("[name=email_code]").value = "";
      q("[data-email-code-form]").hidden = true;
      await showPreview(inlineContactFlow);
    });
  });

  q("[data-phone-form]").addEventListener("submit", function (event) {
    event.preventDefault();
    var typed = q("[name=phone]").value.trim();
    var problem = phoneError(typed);
    if (problem) {
      status(problem, true);
      q("[name=phone]").focus();
      return;
    }
    work(event.submitter, function () {
      return startContact("phone", canonicalPhone(typed));
    });
  });
  q("[data-phone-code-form]").addEventListener("submit", function (event) {
    event.preventDefault();
    work(event.submitter, async function () {
      await api.post("/v1/me/contacts/phone/verify", {
        verificationId: verificationIds.phone,
        code: q("[name=phone_code]").value,
      });
      q("[name=phone_code]").value = "";
      q("[data-phone-code-form]").hidden = true;
      await showPreview(inlineContactFlow);
    });
  });

  dialog.querySelectorAll("[data-contact-resend]").forEach(function (button) {
    button.addEventListener("click", function () {
      var method = button.getAttribute("data-contact-resend");
      var value = pendingContacts[method];
      if (!value) return;
      work(button, function () {
        status(t.sending_code);
        return startContact(method, value);
      });
    });
  });

  q("[data-confirm]").addEventListener("click", function (event) {
    work(event.currentTarget, async function () {
      await confirmPreview(false);
    });
  });
  q("[data-check-status]").addEventListener("click", function (event) {
    work(event.currentTarget, async function () {
      pollCount = 0;
      await checkStatus();
    });
  });
  q("[data-marketing-form]").addEventListener("submit", function (event) {
    event.preventDefault();
    work(event.submitter, async function () {
      await api.put("/v1/me/marketing", {
        subscribed: q("[name=subscribed]").checked,
      });
      await load(true);
      status(t.saved);
    });
  });
  q("[name=photo]").addEventListener("change", function (event) {
    var input = event.currentTarget;
    preparePhoto(input.files && input.files[0]).catch(function () {
      clearPhotoSelection(false);
      photoError(t.photo_invalid, true);
    });
  });
  var photoSurface = q("[data-photo-crop-surface]");
  photoSurface.addEventListener("pointerdown", function (event) {
    if (!photoState.image) return;
    event.preventDefault();
    photoSurface.setPointerCapture(event.pointerId);
    photoState.pointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY,
    });
    photoState.gesture = pointerSnapshot();
    photoSurface.dataset.dragging = "true";
  });
  photoSurface.addEventListener("pointermove", function (event) {
    if (!photoState.pointers.has(event.pointerId) || !photoState.image) return;
    event.preventDefault();
    var previous = photoState.gesture;
    photoState.pointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY,
    });
    var current = pointerSnapshot();
    if (!previous || !current) return;
    if (current.distance && previous.distance)
      photoState.zoom = clamp(
        photoState.zoom * (current.distance / previous.distance),
        1,
        3,
      );
    var rectangle = photoSurface.getBoundingClientRect();
    var scale = PHOTO_OUTPUT_SIZE / Math.max(1, rectangle.width);
    photoState.x += (current.x - previous.x) * scale;
    photoState.y += (current.y - previous.y) * scale;
    photoState.gesture = current;
    drawPhotoCrop();
  });
  photoSurface.addEventListener("pointerup", finishPhotoPointer);
  photoSurface.addEventListener("pointercancel", finishPhotoPointer);
  photoSurface.addEventListener("lostpointercapture", finishPhotoPointer);
  photoSurface.addEventListener(
    "wheel",
    function (event) {
      if (!photoState.image) return;
      event.preventDefault();
      setPhotoZoom(photoState.zoom * Math.exp(-event.deltaY * 0.0015));
    },
    { passive: false },
  );
  photoSurface.addEventListener("keydown", function (event) {
    if (!photoState.image) return;
    var handled = true;
    if (event.key === "ArrowLeft") movePhotoBy(-12, 0);
    else if (event.key === "ArrowRight") movePhotoBy(12, 0);
    else if (event.key === "ArrowUp") movePhotoBy(0, -12);
    else if (event.key === "ArrowDown") movePhotoBy(0, 12);
    else if (event.key === "+" || event.key === "=")
      setPhotoZoom(photoState.zoom + 0.1);
    else if (event.key === "-" || event.key === "_")
      setPhotoZoom(photoState.zoom - 0.1);
    else handled = false;
    if (handled) event.preventDefault();
  });
  q("[data-photo-zoom-out]").addEventListener("click", function () {
    setPhotoZoom(photoState.zoom - 0.1);
    photoSurface.focus();
  });
  q("[data-photo-zoom-in]").addEventListener("click", function () {
    setPhotoZoom(photoState.zoom + 0.1);
    photoSurface.focus();
  });
  q("[data-photo-reset]").addEventListener("click", function () {
    resetPhotoCrop();
    photoSurface.focus();
  });
  q("[data-photo-discard]").addEventListener("click", function () {
    clearPhotoSelection(true);
  });
  q("[data-photo-form]").addEventListener("submit", function (event) {
    event.preventDefault();
    if (!photoState.file || !photoState.image) {
      photoError(t.photo_invalid, true);
      return;
    }
    work(event.submitter, async function () {
      var file = await croppedPhoto();
      var form = new FormData();
      form.append("photo", file, "profile-photo.jpg");
      var result = await api.request("/v1/me/photo", {
        method: "POST",
        form: form,
      });
      await load(true);
      if (result.failed) throw new Error(t.photo_failed);
      status(result.processing ? t.photo_processing : t.saved);
      clearPhotoSelection(false);
      if (result.processing) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          load(true).catch(fail);
        }, 3000);
      }
    });
  });
  q("[data-remove-photo]").addEventListener("click", function (event) {
    work(event.currentTarget, async function () {
      await api.del("/v1/me/photo");
      clearPhotoSelection(false);
      await load(true);
      status(t.saved);
    });
  });

  document.addEventListener("click", function (event) {
    var contactTrigger = event.target.closest("[data-pf-contact-verify]");
    if (contactTrigger) {
      event.preventDefault();
      var method = contactTrigger.getAttribute("data-pf-contact-verify");
      var field = contactTrigger.closest(".pf-demo-field");
      var input =
        field && field.querySelector('[data-pf-contact-kind="' + method + '"]');
      if (input) beginInlineContact(method, input, contactTrigger);
      return;
    }
    var trigger = event.target.closest("[data-pf-account-open]");
    if (!trigger) return;
    event.preventDefault();
    open(trigger.getAttribute("data-pf-account-open") || "all");
  });
  document.addEventListener("input", function (event) {
    var input = event.target.closest("[data-pf-contact-kind]");
    if (!input) return;
    input.dataset.pfContactDirty =
      contactInputValue(input) !== (input.dataset.pfContactCurrent || "").trim()
        ? "true"
        : "false";
    if (input.dataset.pfContactKind === "phone") {
      input.removeAttribute("aria-invalid");
      input.classList.remove("is-invalid");
      var slot = input
        .closest(".pf-demo-field")
        ?.querySelector('[data-pf-field-error="phone"]');
      if (slot) {
        slot.textContent = "";
        slot.hidden = true;
      }
      refreshPhoneControls();
    }
  });
  document.addEventListener("pf:phone-india-message", function (event) {
    var input = event.target;
    var message = event.detail && event.detail.message;
    if (dialog.contains(input)) {
      event.preventDefault();
      status(message, true);
      return;
    }
    var slot = input
      .closest(".pf-demo-field")
      ?.querySelector('[data-pf-field-error="phone"]');
    if (!slot) return;
    event.preventDefault();
    input.setAttribute("aria-invalid", "true");
    input.classList.add("is-invalid");
    slot.textContent = message;
    slot.hidden = false;
  });
  document.addEventListener("pf:profile:hydrated", function (event) {
    var person = event.detail && event.detail.profile;
    if (!person) return;
    renderPerson(person);
  });
  window.PFAccount = {
    open: open,
    strings: t,
    isVerifiedPhone: isVerifiedPhone,
    refreshContactState: refreshPhoneControls,
  };
  var requestedMode = new URL(location.href).searchParams.get("pf_account");
  if (
    requestedMode ||
    new URL(location.href).searchParams.get("pf_contact") === "verified"
  )
    open(requestedMode || "all");
})();
